import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class IpemarksService {
  ipeNavItems: IpeRoleNavItem[] = [];
  ipeRolesLoaded = false;

  constructor(public http: HttpClient, public basemodel: BasemodelService) { }
  private token3 = "";

  /** Filter dropdown caches — reuse until params change (survives dialog open/close). */
  private datesCache: any = null;
  private testListCache = new Map<string, any>();
  private buildingsCache: any = null;
  private buildingsCacheKey = '';
  private sectionListCache = new Map<string, any>();
  private subjectCache = new Map<string, any>();

  private authHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + this.token3,
      'Content-Type': 'application/json'
    });
  }

  getdatelist(): Observable<any> {
    if (this.datesCache) {
      return of(this.datesCache);
    }
    return this.http.get(this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/dates", { headers: this.authHeaders() }).pipe(
      tap((res: any) => { this.datesCache = res; })
    );
  }

  gettestlist(date: any): Observable<any> {
    const key = String(date ?? '');
    if (this.testListCache.has(key)) {
      return of(this.testListCache.get(key));
    }
    return this.http.get(this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/testName?date=" + date, { headers: this.authHeaders() }).pipe(
      tap((res: any) => { this.testListCache.set(key, res); })
    );
  }

  getipebuilding(params?: {
    academicId?: any;
    classId?: any;
    groupId?: any;
    streamId?: any;
    programId?: any;
  }): Observable<any> {
    const key = this.ipeLocationCacheKey(params);
    if (this.buildingsCache && this.buildingsCacheKey === key) {
      return of(this.buildingsCache);
    }
    const qs = this.ipeLocationQuery(params);
    return this.http.get(
      this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/campusBuildings" + qs,
      { headers: this.authHeaders() }
    ).pipe(
      tap((res: any) => {
        this.buildingsCache = res;
        this.buildingsCacheKey = key;
      })
    );
  }

  getsectionlist(
    building: any,
    params?: {
      academicId?: any;
      classId?: any;
      groupId?: any;
      streamId?: any;
      programId?: any;
    }
  ): Observable<any[]> {
    const key = `${building ?? ''}|${this.ipeLocationCacheKey(params)}`;
    if (this.sectionListCache.has(key)) {
      return of(this.sectionListCache.get(key));
    }
    const qs = new URLSearchParams();
    if (building != null && String(building).trim() !== '') {
      qs.set('buildingId', String(building).trim());
    }
    this.appendIpeLocationParams(qs, params);
    return this.http.get(
      this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/buildingSections?" + qs.toString(),
      { headers: this.authHeaders() }
    ).pipe(
      map((res: any) => (Array.isArray(res) ? res : [])),
      catchError((err) => {
        if (err?.status === 204 || err?.status === 404) {
          return of([]);
        }
        return throwError(() => err);
      }),
      tap((res: any[]) => { this.sectionListCache.set(key, res); })
    );
  }

  private ipeLocationCacheKey(params?: {
    academicId?: any;
    classId?: any;
    groupId?: any;
    streamId?: any;
    programId?: any;
  }): string {
    return [
      params?.academicId ?? '',
      params?.classId ?? '',
      params?.groupId ?? '',
      params?.streamId ?? '',
      params?.programId ?? ''
    ].join('|');
  }

  private ipeLocationQuery(params?: {
    academicId?: any;
    classId?: any;
    groupId?: any;
    streamId?: any;
    programId?: any;
  }): string {
    const qs = new URLSearchParams();
    this.appendIpeLocationParams(qs, params);
    const s = qs.toString();
    return s ? '?' + s : '';
  }

  private appendIpeLocationParams(
    qs: URLSearchParams,
    params?: {
      academicId?: any;
      classId?: any;
      groupId?: any;
      streamId?: any;
      programId?: any;
    }
  ): void {
    if (!params) {
      return;
    }
    const add = (key: string, value: any) => {
      if (value != null && String(value).trim() !== '') {
        qs.set(key, String(value).trim());
      }
    };
    add('academicId', params.academicId);
    add('classId', params.classId);
    add('groupId', params.groupId);
    add('streamId', params.streamId);
    add('programId', params.programId);
  }

  getstudentmarkslist(testcode: any, section: any): Observable<any> {
    const headers = this.authHeaders();
    return this.http.get(
      this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/testDetails?testCode=" + testcode + "&sectionId=" + section,
      { headers }
    );
  }

  saveStudentMarks(marks: any): Observable<any> {
    const headers = this.authHeaders();
    return this.http.post(this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/save", marks, { headers });
  }

  checksubject(testcode: any, date: any): Observable<any> {
    const key = `${testcode ?? ''}|${date ?? ''}`;
    if (this.subjectCache.has(key)) {
      return of(this.subjectCache.get(key));
    }
    return this.http.get(
      this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/testSubDetails?testCode=" + testcode + "&date=" + date,
      { headers: this.authHeaders() }
    ).pipe(
      tap((res: any) => { this.subjectCache.set(key, res); })
    );
  }

  Admissionbystudent() {
    const headers = this.authHeaders();
  }

  /** Search by Admission — step 1: validate admission for selected test */
  programBasedStudentSearch(testCode: any, searchCriteria: any): Observable<any> {
    const headers = this.authHeaders();
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/empApp/programBasedStudentSearch?searchCriteria=" +
        encodeURIComponent(searchCriteria ?? '') +
        "&testCode=" + encodeURIComponent(testCode ?? ''),
      { headers }
    );
  }

  /** Search by Admission — load student marks */
  getStdIpeMarks(testCode: any, admNo: any, testDate: any): Observable<any> {
    const headers = this.authHeaders();
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/stdIpeMarks?testCode=" +
        encodeURIComponent(testCode ?? '') +
        "&admNo=" + encodeURIComponent(admNo ?? '') +
        "&testDate=" + encodeURIComponent(testDate ?? ''),
      { headers }
    );
  }

  /** Test Creation — State dropdown (before academic year) */
  getIpeStates(): Observable<any> {
    return this.http.get(this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/states", {
      headers: this.authHeaders()
    });
  }

  /** Test Creation — Current academic year (after state) */
  getAcademicYears(stateId?: any): Observable<any> {
    let url = this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/currentAcademicYear";
    if (stateId != null && String(stateId).trim() !== '') {
      url += "?stateId=" + encodeURIComponent(String(stateId).trim());
    }
    return this.http.get(url, {
      headers: this.authHeaders()
    });
  }
  /** Test Creation — Class dropdown by academicYear (each class includes academicId) */
  getClassestest(academicYear: string): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/testCreationbyClasses?academicYear=" + encodeURIComponent(academicYear || ''),
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Group dropdown by academicYear + classId */
  getGroupstest(academicYear: string, classId: any): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/testCreationByGroups?academicYear=" + encodeURIComponent(academicYear || '') +
        "&classId=" + classId,
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Stream dropdown by academicYear + classId + groupId */
  getStreamstest(academicYear: string, classId: any, groupId: any): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/testCreationByStreams?academicYear=" + encodeURIComponent(academicYear || '') +
        "&classId=" + classId +
        "&groupId=" + groupId,
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Program dropdown by academicYear + classId + groupId + streamId + stateId */
  getProgramNamestest(academicYear: string, classId: any, groupId: any, streamId: any, stateId?: any): Observable<any> {
    let url =
      this.basemodel.getCommonUrl() +
      "/apiV2/ipeMarkss/testCreationByPrograms?academicYear=" + encodeURIComponent(academicYear || '') +
      "&classId=" + encodeURIComponent(classId ?? '') +
      "&groupId=" + encodeURIComponent(groupId ?? '') +
      "&streamId=" + encodeURIComponent(streamId ?? '');
    if (stateId != null && String(stateId).trim() !== '') {
      url += "&stateId=" + encodeURIComponent(String(stateId).trim());
    }
    return this.http.get(url, { headers: this.authHeaders() });
  }
  /** Test Creation — Class dropdown by academicYear */
  getClasses(academicYear: string): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/classesByAcademicYear?academicYear=" + encodeURIComponent(academicYear || ''),
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Group dropdown by academicYear + classId */
  getGroups(academicYear: string, classId: any): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/groupsByAcYearClassId?academicYear=" + encodeURIComponent(academicYear || '') +
        "&classId=" + classId,
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Stream dropdown by academicYear + classId + groupId */
  getStreams(academicYear: string, classId: any, groupId: any): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/streamsByAcYearClassIdGroupId?academicYear=" + encodeURIComponent(academicYear || '') +
        "&classId=" + classId +
        "&groupId=" + groupId,
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Program dropdown by academicYear + classId + streamId */
  getProgramNames(academicYear: string, classId: any, groupId: any,streamId: any): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/programsByAcYearClassIdStreamId?academicYear=" + encodeURIComponent(academicYear || '') +
        "&classId=" + classId +
        "&groupId="+groupId+
        "&streamId=" + streamId,
      { headers: this.authHeaders() }
    );
  }

  /** Test Creation — Test Type dropdown */
  getTestTypes(): Observable<any> {
    return this.http.get(this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/testTypes", {
      headers: this.authHeaders()
    });
  }

  /** Test Creation — Subject max marks by groupName + testType + stateId */
  getTestSubjects(groupName: string, testType: string, stateId?: any): Observable<any> {
    let url =
      this.basemodel.getCommonUrl() +
      "/apiV2/ipeMarkss/testSubjects?groupName=" + encodeURIComponent(groupName || '') +
      "&testType=" + encodeURIComponent(testType || '');
    if (stateId != null && String(stateId).trim() !== '') {
      url += "&stateId=" + encodeURIComponent(String(stateId).trim());
    }
    return this.http.get(url, { headers: this.authHeaders() });
  }

  /** Test Creation — Create test */
  createTest(payload: any): Observable<any> {
    return this.http.post(
      this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/createTest",
      payload,
      { headers: this.authHeaders() }
    );
  }

  /** Search by Admission — tests between fromDate and toDate (dd-MM-yyyy) */
  getTestsInBetweenDates(fromDate: string, toDate: string): Observable<any> {
    return this.http.get(
      this.basemodel.getCommonUrl() +
        "/apiV2/ipeMarkss/testsInBetweenDates?fromDate=" + encodeURIComponent(fromDate || '') +
        "&toDate=" + encodeURIComponent(toDate || ''),
      { headers: this.authHeaders() }
    );
  }

  /** IPE Marks Entry — Test names by academic / class / group / stream / program / testType */
  getIpeTestNames(
    academicId: any,
    classId: any,
    groupId: any,
    streamId: any,
    programId: any,
    testType: string
  ): Observable<any> {
    const params =
      "academicId=" + encodeURIComponent(academicId ?? '') +
      "&classId=" + encodeURIComponent(classId ?? '') +
      "&groupId=" + encodeURIComponent(groupId ?? '') +
      "&streamId=" + encodeURIComponent(streamId ?? '') +
      "&programId=" + encodeURIComponent(programId ?? '') +
      "&testType=" + encodeURIComponent(testType || '');
    return this.http.get(
      this.basemodel.getCommonUrl() + "/apiV2/ipeMarkss/ipeTestNames?" + params,
      { headers: this.authHeaders() }
    );
  }

  /**
   * Role API (`userAppForms`) — IPE module only uses Test Creation + Marks Entry.
   */
  parseIpeNavFromRoles(res: any): IpeRoleNavItem[] {
    const catalog: Record<string, { path: string; icon: string; order: number; defaultLabel: string }> = {
      IPE_TEST_CREATION: {
        path: '/IpeTestCreation',
        icon: 'fa fa-plus',
        order: 1,
        defaultLabel: 'IPE Test Creation'
      },
      IPE_MARKS_ENTRY: {
        path: '/IpeMarks',
        icon: 'fa fa-edit',
        order: 2,
        defaultLabel: 'IPE Marks Entry'
      },
      IPE_MARKS: {
        path: '/IpeMarks',
        icon: 'fa fa-edit',
        order: 2,
        defaultLabel: 'IPE Marks Entry'
      }
    };
    const groups = res?.userAppForms ?? res?.data?.userAppForms ?? [];
    const forms = (Array.isArray(groups) ? groups : []).flatMap((g: any) =>
      Array.isArray(g?.appForms) ? g.appForms : []
    );
    const byPath = new Map<string, IpeRoleNavItem>();
    for (const form of forms) {
      const name = String(form?.appFormName ?? '').trim();
      const meta = catalog[name] ?? catalog[name.toUpperCase()];
      if (!meta || byPath.has(meta.path)) {
        continue;
      }
      const label = String(form?.appFormLabel ?? '').trim() || meta.defaultLabel;
      byPath.set(meta.path, {
        formName: name,
        label,
        path: meta.path,
        icon: meta.icon,
        order: meta.order,
        addDetails: form?.addDetails !== false,
        updateDetails: form?.updateDetails !== false
      });
    }
    this.ipeNavItems = [...byPath.values()].sort((a, b) => a.order - b.order);
    this.ipeRolesLoaded = true;
    return this.ipeNavItems;
  }

  /** Role has Test Creation with addDetails (defaults true if the form is present). */
  canCreateIpeTest(): boolean {
    if (!this.ipeRolesLoaded) {
      return false;
    }
    const item = this.ipeNavItems.find((n) => n.path === '/IpeTestCreation');
    return !!item && item.addDetails !== false;
  }

  /** Role has Marks Entry with updateDetails (defaults true if the form is present). */
  canUpdateIpeMarks(): boolean {
    if (!this.ipeRolesLoaded) {
      return false;
    }
    const item = this.ipeNavItems.find((n) => n.path === '/IpeMarks');
    return !!item && item.updateDetails !== false;
  }
}

export interface IpeRoleNavItem {
  formName: string;
  label: string;
  path: string;
  icon: string;
  order: number;
  addDetails: boolean;
  updateDetails: boolean;
}
